import { OEMProfile } from "../../../types/Profiles/oemProfile.types"

interface Props {
  profile: OEMProfile
}

function getStatusClass(status: string) {
  if (status === "Pending") return "bg-warning-subtle text-warning"
  if (status === "Active") return "bg-primary-subtle text-primary"
  return "bg-success-subtle text-success"
}

function getDotClass(color: string) {
  switch (color) {
    case "primary":
      return "bg-primary"
    case "success":
      return "bg-success"
    case "warning":
      return "bg-warning"
    case "danger":
      return "bg-danger"
    default:
      return "bg-info"
  }
}

export default function ActivityTab({ profile }: Props) {
  return (
    <div className="row g-4">
      <div className="col-xl-5">
        <div className="card border-0 shadow-sm rounded-4 h-100">
          <div className="card-body p-4">
            <h4 className="fw-semibold mb-4">User Activity Timeline</h4>

            <div className="timeline">
              {profile.timeline.map((item, index) => (
                <div key={index} className="d-flex mb-4">
                  <div className="me-3 pt-1">
                    <span
                      className={`d-inline-block rounded-circle ${getDotClass(item.color)}`}
                      style={{ width: 10, height: 10 }}
                    />
                  </div>

                  <div>
                    <h6 className="mb-1">{item.title}</h6>
                    <p className="text-muted mb-1">{item.description}</p>
                    <small className="text-muted">{item.dateLabel}</small>
                  </div>
                </div>
              ))}
            </div>

            <button className="btn btn-primary w-100 rounded-3 mt-2">
              View History
            </button>
          </div>
        </div>
      </div>

      <div className="col-xl-7">
        <div className="card border-0 shadow-sm rounded-4 h-100">
          <div className="card-body p-4">
            <h4 className="fw-semibold mb-4">History</h4>

            <div className="table-responsive">
              <table className="table align-middle">
                <thead>
                  <tr>
                    <th>RFQ</th>
                    <th>Part Name</th>
                    <th>Supplier</th>
                    <th>Status</th>
                    <th>Pursue</th>
                  </tr>
                </thead>
                <tbody>
                  {profile.history.map((row, index) => (
                    <tr key={index}>
                      <td>{row.rfqCode}</td>
                      <td>{row.partName}</td>
                      <td>{row.supplier}</td>
                      <td>
                        <span className={`badge rounded-pill ${getStatusClass(row.status)}`}>
                          {row.status}
                        </span>
                      </td>
                      <td>{row.pursue}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="text-end">
              <button className="btn btn-link text-decoration-none">
                View History →
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}